import { DeleteIcon} from '@chakra-ui/icons';

const ClearIndicator = (props) => {
    const {
        innerRef,
        innerProps,
        selectProps: { setSelectedOption, setInputValue, onChange }
    } = props;

    const handleClick = (e) => {
        e.stopPropagation();
        setSelectedOption(null);
        setInputValue('');
        onChange(undefined);
        props.clearValue();
    };

    return (
        <DeleteIcon
            ref={innerRef}
            {...innerProps}
            onClick={handleClick}
            color="#9FABCB"
            boxSize={5}
            cursor="pointer"
        />
    );
};

 export default ClearIndicator;
